// extracted by mini-css-extract-plugin
export default {"container":"register_container__CAWUy","logoContainer":"register_logoContainer__WngPk"};